import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { ActivityCatalogKey } from './activity.i18n.js';
import { ACTIVITY_CATALOG } from './activity.i18n.js';

export type ActivityMessageId = `activity:${ActivityCatalogKey}`;

const PREFIX_LENGTH = 'activity:'.length;

/** `t()` for the stop-gap `activity:` scope (see `activity.i18n.ts`). */
export function useActivityT(): { t: (id: ActivityMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: ActivityMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as ActivityCatalogKey;
      const raw = ACTIVITY_CATALOG[locale][key] ?? ACTIVITY_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
